import React, { Component } from 'react';
import { Container, Accordion, Icon, Checkbox, Button } from 'semantic-ui-react';
import { PtInput, PtSelect, PtDateInput } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import ScrollArea from 'react-scrollbar';
import '../../../index.css';
import config from '../../../config.json';
import '../../../index.css';

export default class Condition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.pointModel,
            selectedIndex: 0
        }


    }
    render() {
        const { activityOptions } = DropdownLib.getDropdowns().Signs_Activity
        const { reasonOptions } = DropdownLib.getDropdowns().Signs_Activity
        const activityDate = this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i) {
                return (

                    <PtDateInput key={i} label='Activity Date'
                        placeholder="Not Available" whichInput="firsttb" inputType="hwy" name="ActivityDate"
                        disabled={this.props.disabled}
                        value={a.ActivityDate ? a.ActivityDate.slice(0, 10) : null} minDate={new Date(1900, 0, 1)}
                        onChange={(date) => this.onChangeDate(date, "ActivityDate")} />
                )
            }
        })

        const activityType = this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i)
                return (
                    <PtSelect key={i} label="Activity Type" options={activityOptions} disabled={this.props.disabled}
                        name="ActivityType_Option" defaultVal={a.ActivityType_Option === null ? 0 : a.ActivityType_Option}
                        onChange={this.onChangeDropdown} />
                )
        })
        const reasonType = this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i)
                return (
                    <PtSelect key={i} label="Reason Type" options={reasonOptions} disabled={this.props.disabled}
                        name="ActivityReason_Option" defaultVal={a.ActivityReason_Option === null ? 0 : a.ActivityReason_Option}
                        onChange={this.onChangeDropdown} />
                )
        })

        const activityComment = this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i)
                return (
                    <PtInput key={i} label="Comment" value={a.Comment === null ? '' : a.Comment}
                        onChange={this.onInputChange} name="Comment" disabled={this.props.disabled} />

                )
        })

        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    {/* Add css classes to these later */}
                    <div style={{ width: 60, float: 'left' }
                    }>
                        <PtSelect key={this.props.pointModel.Activity.data} name='availableActivity' options={this.props.pointModel.Activity.data}
                            defaultVal={this.state.selectedIndex}
                            onChange={this.onChangeIndex} />

                    </div>


                    <strong style={{ float: 'left', paddingTop: 10 }}>of {this.state.Activity.data.length}</strong>
                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 20 }} size='tiny' color='blue' onClick={() => {
                        this.addNewRecord();
                    }}
                        disabled={this.props.disabled}
                    >New</Button>
                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 20 }} size='tiny' color='red' onClick={() => {
                        this.deleteRecord(this.state.selectedIndex);
                    }}
                        disabled={this.props.disabled}
                    >Delete</Button>
                    {activityDate}
                    {activityType}
                    {reasonType}
                    {activityComment}
                </ScrollArea>
            </Container>
        )
    }
    //render(){ return(this.renderForm()) }

    addNewRecord() {
        const date = new Date();
        this.props.pointModel.Activity.data.push({
            Id: 0,
            key: this.props.pointModel.Activity.data.length,
            value: this.props.pointModel.Activity.data.length,
            label: this.props.pointModel.Activity.data.length + 1,
            ActivityDate: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`, ActivityType_Option: null, ActivityReason_Option: null, Comment: null, ActivityReason: null, ActivityType: null
        })
        const tempArray = this.props.pointModel;
        this.setState({
            [this.props.pointModel.Activity]: tempArray,
            selectedIndex: [this.props.pointModel.Activity.data.length] - 1
        })
    }

    deleteRecord(index) {
        this.props.triggerNeedSave()
        this.props.pointModel.Activity.data = this.props.pointModel.Activity.data.filter(item => {
            return item.key !== index
        })

        this.props.pointModel.Activity.data.map((data, i) => {
            if (data.key >= index) {
                data.key = data.key - 1
                data.value = data.value - 1
                data.label = data.label - 1
            }
        })

        const tempArray = this.props.pointModel;
        console.log(tempArray)
        this.setState({
            [this.props.pointModel.Activity]: tempArray,
            selectedIndex: index == 0 ? index : index - 1
        })
    }

    onChangeIndex = (e) => {
        const { target } = e;
        const { value } = target;
        this.setState({ selectedIndex: parseInt(value) });
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i) {
                if (date instanceof Date && !isNaN(date)) {
                    this.setState({ [this.props.pointModel.Activity.data[i][name]]: date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null });
                    this.props.pointModel.Activity.data[i][name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
                }
                else {
                    this.setState({ [this.props.pointModel.Activity.data[i][name]]: null });
                }
            }
        })

    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();

        this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i) {
                this.setState({ [this.props.pointModel.Activity.data[i][name]]: value === '' ? null : value });
                this.props.pointModel.Activity.data[i][name] = value
            }
        })

    }
    onChangeDropdown = (e) => {
        const { activityOptions } = DropdownLib.getDropdowns().Signs_Activity
        const { reasonOptions } = DropdownLib.getDropdowns().Signs_Activity
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        console.log(name.split('_')[0])

        this.state.Activity.data.map((a, i) => {
            if (this.state.selectedIndex === i) {
                a[name] = parseInt(value)
                if (name.split('_')[0] === 'ActivityType') {
                    const activityTypeValue = activityOptions[parseInt(value)].label;
                    a[name.split('_')[0]] = activityTypeValue;
                    const activityValue = this.props.pointModel.Activity.data[i];

                    if (activityValue.Id == 0 && (activityTypeValue == 'Replacement' || activityTypeValue == 'Original Installation')) {
                        alert('Sign stock will decrease automatically!');
                        this.onChangeDate(new Date(), 'ActivityDate');
                    }
                }
                else if (name.split('_')[0] === 'ActivityReason') {
                    a[name.split('_')[0]] = reasonOptions[parseInt(value)].label
                }
                this.props.pointModel.Activity.data[i][name] = parseInt(value)
            }
        })

    }


}


// WEBPACK FOOTER //
// ./src/layers/tabs/sign/activity.js